"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardItemHeadline = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_truncate_1 = tslib_1.__importDefault(require("react-truncate"));
var DashboardItemHeadlineContainer_1 = require("./DashboardItemHeadlineContainer");
exports.DashboardItemHeadline = function (_a) {
    var title = _a.title, clientHeight = _a.clientHeight;
    return (react_1.default.createElement(DashboardItemHeadlineContainer_1.DashboardItemHeadlineContainer, { clientHeight: clientHeight },
        react_1.default.createElement(react_truncate_1.default, { lines: 2, ellipsis: "...", className: "item-headline-inner s-headline" }, title)));
};
//# sourceMappingURL=DashboardItemHeadline.js.map